var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "批次名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.activityName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "activityName", $$v)
                      },
                      expression: "searchInfo.activityName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.activityStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activityStatus", $$v)
                        },
                        expression: "searchInfo.activityStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "启用", value: 1 } },
                        [_vm._v("启用")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "禁用", value: 2 } },
                        [_vm._v("禁用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.onAdd }
                    },
                    [_vm._v("新增批次")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "批次编号", prop: "activityNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "批次名称", prop: "activityName" }
          }),
          _c("el-table-column", { attrs: { label: "数量", prop: "num" } }),
          _c("el-table-column", {
            attrs: { label: "单个码可重复兑换次数", prop: "codeRepeatNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "dateStart" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateStart)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "dateEnd" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateEnd)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "activityStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warn", effect: "plain" } },
                          [_vm._v("待审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("审核不通过")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("已启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("已禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "400px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("规则")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toCodeList(scope.row)
                          }
                        }
                      },
                      [_vm._v("兑换码")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onDownload(scope.row)
                          }
                        }
                      },
                      [_vm._v("下载")]
                    ),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAudit(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAble(scope.row)
                              }
                            }
                          },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onDisable(scope.row)
                              }
                            }
                          },
                          [_vm._v("禁用")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewDialogVisible,
            title: "查看兑换规则",
            "custom-class":
              "bairun-dialog bairun-dialog-exchange-code bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: {
                        "label-width": "250px",
                        model: _vm.formData,
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("基本规则")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "批次名称：" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formData.activityName) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "有效时间：" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formData.dateStart) +
                                      "   ~   " +
                                      _vm._s(_vm.formData.dateEnd) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("兑换码规则")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "生成兑换码数量：" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.formData.dateStart) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "每个码可重复兑换次数：" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formData.codeRepeatNum) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("用户规则")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "可重复兑换：" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.isRepeat,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "isRepeat",
                                            $$v
                                          )
                                        },
                                        expression: "formData.isRepeat"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("不重复")
                                      ]),
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("重复")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "每天可兑换次数：" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.formData.perdayLimit) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "本批次可兑换次数：" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.formData.allLimit) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("兑换商品")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "兑换积分：" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.formData.points) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "兑换券：" } },
                                _vm._l(
                                  _vm.formData.exchangeTicketList,
                                  function(item, index) {
                                    return _c(
                                      "el-row",
                                      { staticClass: "ticket-form-item" },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "券编号",
                                                  prop:
                                                    "exchangeTicketList." +
                                                    index +
                                                    ".ticketRuleNo"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "输入券编号"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.getTicketDetail(
                                                        item
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: item.ticketRuleNo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ticketRuleNo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.ticketRuleNo"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "数量",
                                                  prop:
                                                    "exchangeTicketList." +
                                                    index +
                                                    ".num"
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请输入张数",
                                                    min: 1
                                                  },
                                                  model: {
                                                    value: item.num,
                                                    callback: function($$v) {
                                                      _vm.$set(item, "num", $$v)
                                                    },
                                                    expression: "item.num"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "bairun-form-item-label-suffix"
                                                  },
                                                  [_vm._v("张")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-exchange-code bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: {
                        "label-width": "250px",
                        model: _vm.formData,
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("基本规则")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "批次名称：",
                                    prop: "activityName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.activityName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "activityName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.activityName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "活动时间：",
                                    prop: "dateRangeValueArr"
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetimerange",
                                      align: "right",
                                      "unlink-panels": "",
                                      "range-separator": "至",
                                      "start-placeholder": "开始(含当天)",
                                      "end-placeholder": "结束(含当天)",
                                      format: "yyyy-MM-dd HH:mm:ss",
                                      "value-format": "yyyy-MM-dd HH:mm:ss"
                                    },
                                    model: {
                                      value: _vm.dateRangeValueArr,
                                      callback: function($$v) {
                                        _vm.dateRangeValueArr = $$v
                                      },
                                      expression: "dateRangeValueArr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("兑换码规则")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "生成模式：" }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.batchMode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "batchMode",
                                            $$v
                                          )
                                        },
                                        expression: "formData.batchMode"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("自动批量生成")
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("自定义兑换码")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.formData.batchMode === 1
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: { label: "生成兑换码数量：" }
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          controls: false,
                                          min: 1,
                                          placeholder: "请输入数量"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.formData.num,
                                          callback: function($$v) {
                                            _vm.$set(_vm.formData, "num", $$v)
                                          },
                                          expression: "formData.num "
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formData.batchMode === 2
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: { label: "自定义兑换码：" }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          placeholder:
                                            "请输入兑换码，长度10位以内",
                                          maxlength: "10"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.formData.code,
                                          callback: function($$v) {
                                            _vm.$set(_vm.formData, "code", $$v)
                                          },
                                          expression: "formData.code "
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "每个码可重复兑换次数：" }
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 1,
                                      placeholder: "请输入"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.codeRepeatNum,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "codeRepeatNum",
                                          $$v
                                        )
                                      },
                                      expression: "formData.codeRepeatNum "
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("用户规则")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "可重复兑换：" }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.isRepeat,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "isRepeat",
                                            $$v
                                          )
                                        },
                                        expression: "formData.isRepeat"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("不重复")
                                      ]),
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("重复")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "每天可兑换次数：" }
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 1,
                                      placeholder: "请输入次数"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.perdayLimit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "perdayLimit",
                                          $$v
                                        )
                                      },
                                      expression: "formData.perdayLimit "
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "本批次可兑换次数：" }
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 1,
                                      placeholder: "请输入次数"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.allLimit,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "allLimit", $$v)
                                      },
                                      expression: "formData.allLimit "
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("兑换商品")
                          ]),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "兑换积分：" } },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 0,
                                      clearable: "",
                                      placeholder: "请输入积分"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.points,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "points", $$v)
                                      },
                                      expression: "formData.points"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 16 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "兑换券：" } },
                                _vm._l(
                                  _vm.formData.exchangeTicketList,
                                  function(item, index) {
                                    return _c(
                                      "el-row",
                                      { staticClass: "ticket-form-item" },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "券编号",
                                                  prop:
                                                    "exchangeTicketList." +
                                                    index +
                                                    ".ticketRuleNo"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled:
                                                      _vm.type == "update",
                                                    clearable: "",
                                                    placeholder: "输入券编号"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.getTicketDetail(
                                                        item
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: item.ticketRuleNo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ticketRuleNo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.ticketRuleNo"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "数量",
                                                  prop:
                                                    "exchangeTicketList." +
                                                    index +
                                                    ".num"
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  attrs: {
                                                    disabled:
                                                      _vm.type == "update",
                                                    clearable: "",
                                                    placeholder: "请输入张数",
                                                    min: 1
                                                  },
                                                  model: {
                                                    value: item.num,
                                                    callback: function($$v) {
                                                      _vm.$set(item, "num", $$v)
                                                    },
                                                    expression: "item.num"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "bairun-form-item-label-suffix"
                                                  },
                                                  [_vm._v("张")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.type != "update"
                                          ? _c(
                                              "el-col",
                                              {
                                                staticClass:
                                                  "btn-tool-balancrange",
                                                attrs: { span: 2 }
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "btn-tool-balancrange",
                                                        attrs: {
                                                          type: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onDeleteTicket(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("-")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.type != "update"
                                          ? _c(
                                              "el-col",
                                              {
                                                staticClass:
                                                  "btn-tool-balancrange",
                                                attrs: { span: 2 }
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onAddTicket(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("+")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.auditDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-audit bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.auditDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "审核结果：",
                                    prop: "auditStatus"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("通过")
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("不通过")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审核意见：",
                                    prop: "auditRemark"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入",
                                      rows: "5"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }